import getFormatTime from './timeFormat';
import getProjectLabel from './project';
import getFacilityState from './facility';
export default Object.assign({},getFormatTime,getProjectLabel,getFacilityState);

export {
    getFormatTime
}



// WEBPACK FOOTER //
// ./src/filter/index.js